module.exports = __webpack_public_path__ + "img/ico-11-active.ec18f206.svg";